import DataTable from 'react-data-table-component';
import LoaderComponent from '@components/atom/layout/loader';
import FadeLoader from 'react-spinners/FadeLoader';

const GridExpandableAtom = ({ columns, data, height, ExpandedComponent }) => {
  return (
    <DataTable
      columns={columns}
      data={data}
      pagination
      progressPending={!data && !columns}
      progressComponent={
        <LoaderComponent height={height}>
          {/* <FadeLoader /> */}
          <img src={`${process.env.PUBLIC_URL}/styles/images/AIXLOGO.gif`} />
        </LoaderComponent>
      }
      expandableRows={true}
      expandableRowsComponent={ExpandedComponent}
    />
  );
};

export default GridExpandableAtom;
